import gql from 'graphql-tag'

export const GET_POPULAR_BLOGS = gql`
  query getAllPopularBlogs {
    getAllPopularBlogs
  }
`
